import { render, staticRenderFns } from "./WechatOfficialAccountManage.vue?vue&type=template&id=3e8741de&scoped=true"
import script from "./WechatOfficialAccountManage.vue?vue&type=script&lang=js"
export * from "./WechatOfficialAccountManage.vue?vue&type=script&lang=js"
import style0 from "./WechatOfficialAccountManage.vue?vue&type=style&index=0&id=3e8741de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8741de",
  null
  
)

export default component.exports